export default __webpack_public_path__ + "static/Butler-ExtraBold-807412182ba5b9eea592bb90215dfafa.woff";